import { render } from "./Landingpage.vue?vue&type=template&id=733e3043&scoped=true"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"

import "./Landingpage.vue?vue&type=style&index=0&id=733e3043&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-733e3043"

export default script